"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryAiCallsByPlatformEplIds = exports.createAiCall = exports.updateCallStatus = exports.queryClientCallsByPlatformEplIds = exports.loadCorrespondencePartialData = void 0;
var tslib_1 = require("tslib");
var api_1 = tslib_1.__importStar(require("./api"));
var CLIENT_INTEGRATION_URL = process.env.REACT_APP_BCG_TRANSFORMER_URL;
function loadCorrespondencePartialData(projectId, offset) {
    if (offset === void 0) { offset = 0; }
    return api_1.default.get("".concat(CLIENT_INTEGRATION_URL, "/project/").concat(projectId, "/correspondence"), { params: { offset: offset, limit: 10 } })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.loadCorrespondencePartialData = loadCorrespondencePartialData;
function queryClientCallsByPlatformEplIds(eplIds) {
    return api_1.default.post("".concat(CLIENT_INTEGRATION_URL, "/call/queryByPlatformEplIds"), { eplIds: eplIds })
        .then(api_1.extractData)
        .then(function (data) { return (data === null || data === void 0 ? void 0 : data.calls) || []; })
        .catch(api_1.errorHandler);
}
exports.queryClientCallsByPlatformEplIds = queryClientCallsByPlatformEplIds;
function updateCallStatus(_a) {
    var status = _a.status, schedule = _a.schedule, platformEplId = _a.platformEplId, projectId = _a.projectId, cancelationReason = _a.cancelationReason, totalCost = _a.totalCost;
    return api_1.default
        .post("".concat(CLIENT_INTEGRATION_URL, "/call/status"), {
        status: status,
        schedule: schedule,
        platformEplId: platformEplId,
        projectId: projectId,
        cancelationReason: cancelationReason,
        totalCost: totalCost,
    })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.updateCallStatus = updateCallStatus;
function createAiCall(eplId, _a) {
    var url = _a.url, deadline = _a.deadline;
    return api_1.default.post("".concat(CLIENT_INTEGRATION_URL, "/ai-call/").concat(eplId), { url: url, deadline: deadline })
        .then(api_1.extractData)
        .catch(api_1.errorHandler);
}
exports.createAiCall = createAiCall;
function queryAiCallsByPlatformEplIds(eplIds) {
    return api_1.default.post("".concat(CLIENT_INTEGRATION_URL, "/ai-call/queryByPlatformEplIds"), { eplIds: eplIds })
        .then(api_1.extractData)
        .then(function (data) { return (data === null || data === void 0 ? void 0 : data.calls) || []; })
        .catch(api_1.errorHandler);
}
exports.queryAiCallsByPlatformEplIds = queryAiCallsByPlatformEplIds;
var api = {
    loadCorrespondencePartialData: loadCorrespondencePartialData,
};
exports.default = api;
